import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";

const DataDeletionPage = () => {
  const hero = (
    <PageHero
      eyebrow="Yasal"
      title="Veri Silme Talebi"
      subtitle="Verasist'e bağladığınız hesaplar (Instagram, WhatsApp, Google, e-posta ve diğer entegrasyonlar) üzerinden işlenen verilerinizin silinmesini nasıl talep edebileceğinizi bu sayfada bulabilirsiniz."
    />
  );

  const Content = ({ children }) => (
    <section className="py-12 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="space-y-10 text-[14.5px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.88 }}>
          {children}
        </div>
      </div>
    </section>
  );

  const H2 = ({ children }) => <h2 className="text-[20px] font-bold" style={{ color: "var(--fg)" }}>{children}</h2>;
  const P = ({ children }) => <p>{children}</p>;
  const Ul = ({ children }) => <ul className="space-y-2 list-disc pl-5">{children}</ul>;
  const Li = ({ children }) => <li>{children}</li>;

  return (
    <PageLayout hero={hero}>
      <SectionReveal>
        <Content>
          <div>
            <H2>1. Veri Silme Talebi Nasıl Yapılır?</H2>
            <P>Verasist platformuna bağladığınız hesaplarınıza (Instagram, WhatsApp Business, Google Workspace, e-posta ve diğer entegrasyonlar) ait verilerin ve bu bağlantılar aracılığıyla işlenen kişisel verilerinizin silinmesini talep etmek için aşağıdaki yollardan birini kullanabilirsiniz:</P>
            <Ul>
              <Li><strong>E-posta ile:</strong> <a href="mailto:kvkk@verasist.ai" style={{ color: "var(--brand-cyan)" }}>kvkk@verasist.ai</a> adresine, hesabınızla ilişkili e-posta adresinizi ve silinmesini istediğiniz veri/entegrasyonu belirterek bir talep gönderin.</Li>
              <Li><strong>Uygulama üzerinden:</strong> Verasist paneline giriş yaparak <strong>Kanallar (Channels)</strong> sayfasından ilgili entegrasyonu (örn. Instagram) kaldırabilir, <strong>Ayarlar</strong> sayfasından hesabınızı ve tüm verilerinizi kalıcı olarak silme talebinde bulunabilirsiniz.</Li>
            </Ul>
          </div>

          <div>
            <H2>2. Talebiniz Üzerine Neler Silinir?</H2>
            <P>Doğrulanmış bir silme talebi üzerine aşağıdaki veriler kalıcı olarak silinir:</P>
            <Ul>
              <Li>İlgili sosyal medya/mesajlaşma entegrasyonuna (örn. Instagram, WhatsApp) ait erişim jetonları (access token) ve bağlantı bilgileri</Li>
              <Li>Bu entegrasyon üzerinden alınmış/gönderilmiş mesaj, gönderi ve yorum kayıtları</Li>
              <Li>Hesap kapatma talebi hâlinde tüm görüşme kayıtları, transkriptler ve kullanım verileri</Li>
            </Ul>
            <P>Yasal saklama yükümlülüğü bulunan veriler (örn. fatura kayıtları) ilgili mevzuatta öngörülen süre boyunca ayrıca saklanabilir.</P>
          </div>

          <div>
            <H2>3. İşlem Süresi</H2>
            <P>Silme talepleri, kimlik doğrulaması yapıldıktan sonra en geç <strong>30 gün</strong> içinde sonuçlandırılır ve tarafınıza e-posta yoluyla bilgi verilir.</P>
          </div>

          <div>
            <H2>4. İletişim</H2>
            <P>Veri silme talepleriniz veya sorularınız için: <a href="mailto:kvkk@verasist.ai" style={{ color: "var(--brand-cyan)" }}>kvkk@verasist.ai</a></P>
            <P className="mt-2 text-[13px]" style={{ opacity: 0.7 }}>Ayrıca bkz. <a href="/privacy" style={{ color: "var(--brand-cyan)" }}>Gizlilik Politikası</a></P>
          </div>
        </Content>
      </SectionReveal>
    </PageLayout>
  );
};

export default DataDeletionPage;
